// Sites translations for React Admin resource
export const sitesResource = {
  name: '充電站',
  fields: {
    id: 'ID',
    name: '名稱',
    siteName: '站點名稱',
    premisesName: '場地名稱',
    vendor: '供應商',
    vendorName: '供應商',
    merchant: '商戶',
    address: '地址',
    latitude: '緯度',
    longitude: '經度',
    parkingInfo: '停車資訊',
    parkingWeekdayRate: '平日收費',
    parkingWeekendRate: '週末收費',
    parkingPublicHolidayRate: '公眾假期費率',
    parkingFreeMinutes: '免費泊車分鐘',
    parkingPromotion: '優惠/折扣',
    restrictions: '限制',
    heightLimit: '高度限制',
    security: '保安',
    restrictionNotes: '其他限制',
    location: '位置',
    district: '地區',
    addressLine1: '地址第一行',
    addressLine2: '地址第二行',
    city: '城市',
    state: '省/州',
    postalCode: '郵遞區號',
    country: '國家',
    region: '地區',
    timezone: '時區',
    phone: '電話',
    email: '電子郵件',
    supportPhone: '客服電話',
    website: '網站',
    accessType: '存取類型',
    isActive: '啟用',
    chargerCount: '充電樁總數',
    availableChargers: '可用充電樁',
    currentTotalPower: '目前用電量',
    totalMaxPower: '總最大功率 (kW)',
    gridConnectionCapacity: '電網容量 (kW)',
    parkingType: '停車類型',
    hasCanopy: '有遮雨棚',
    reservationEnabled: '啟用預約',
    emailReceiptEnabled: '發送電郵收據',
    appAccessEnabled: '開放手機應用程式',
    kioskAccessEnabled: '開放付款亭',
    primaryImage: '主要圖片',
    images: '圖片',
    imageCaption: '圖片說明',
    notes: '備註',
    amenities: '設施',
    operatingHours: '營業時間',
    operatingAccess: '營業時間類型',
    pricingInfo: '價格資訊',
    qrCode: '手動輸入碼',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
};

// Custom sites translations for components
export const sites = {
  accessTypes: {
    public: '公共',
    private: '私人',
    restricted: '限制使用',
    undefined: '未知',
  },
  operatingAccess: {
    '24_7': '24/7 全天開放',
    'daily': '每日固定時間',
    'varies': '每日時間不同',
    'restricted': '限制開放',
    'closed': '暫時關閉',
  },
  parkingTypes: {
    street: '路邊停車',
    garage: '停車場',
    lot: '停車場',
    dedicated: '電動車專用停車位',
  },
  list: {
    title: '充電站',
    filters: {
      search: '按名稱、地址或城市搜尋',
      activeOnly: '僅顯示啟用',
      accessType: '存取類型',
      city: '城市',
      state: '省/州',
    },
  },
  edit: {
    title: '編輯充電站',
    backToList: '返回充電站列表',
    basicInfo: '基本資訊',
    contactInfo: '聯絡資訊',
    accessStatus: '存取與狀態',
    chargerInfo: '充電樁資訊',
    features: '功能與設施',
    parkingRestrictions: '停車與限制',
    additionalInfo: '附加資訊',
    deleteSite: '刪除充電站',
    deleteSiteDescription: '永久刪除此充電站及所有相關資料',
    cannotDeleteWithChargers: '無法刪除有充電樁的充電站。請先移除所有充電樁。',
    activeSite: '啟用的充電站',
    postalCodeHelp: '在香港為選填',
    deleteConfirmTitle: '刪除充電站',
    deleteConfirmWarning: '警告：此操作無法復原。',
    deleteConfirmMessage: '您即將刪除充電站',
    deleteConfirmInfo: '所有相關資料將被永久移除。',
    deleteConfirmPrompt: '要確認刪除，請輸入充電站名稱',
    deleteConfirmPromptBelow: '在下方：',
    deleteConfirmTypePlaceholder: '輸入「%{name}」以確認',
    nameDoesNotMatch: '充電站名稱不匹配',
    deleteButton: '刪除充電站',
    notesHelperText: '關於此充電站的附加備註或特殊說明',
    primaryImageHelp: '主要充電站圖片的網址',
    vendorHelperText: '選擇或更改此充電站的商戶',
    noMerchantAssigned: '未分配商戶',
    parkingWeekdayRateHelp: '每小時費率（例如：25 = 每小時 $25）',
    parkingWeekendRateHelp: '每小時費率（例如：30 = 每小時 $30）',
    publicHolidayRateHelp: '公眾假期每小時費率',
    freeMinutesHelp: '免費分鐘數（0 = 無免費泊車）',
  },
  create: {
    title: '建立充電站',
    subtitle: '新增充電站位置',
    infoMessage: '建立新的充電站。您可以在建立後為此充電站新增充電樁。',
    basicInfo: '基本資訊',
    contactInfo: '聯絡資訊',
    accessStatus: '存取與狀態',
    features: '功能與設施',
    powerInfo: '電力資訊',
    parkingRestrictions: '停車與限制',
    additionalInfo: '附加資訊',
    nameHelperText: '充電站的描述性名稱',
    premisesNameHelperText: '場地或建築物名稱',
    latitudeHelperText: 'GPS 緯度座標（例如：22.3193）',
    longitudeHelperText: 'GPS 經度座標（例如：114.1694）',
    addressHelperText: '主要街道地址',
    postalCodeHelperText: '香港地址為選填',
    phoneHelperText: '充電站聯絡電話',
    emailHelperText: '充電站查詢電子郵件',
    websiteHelperText: '網站網址（例如：https://example.com）',
    activeSite: '啟用的充電站',
    emailReceiptHelperText: '關閉時，充電結算後不會發送電郵收據，推送通知中也不會顯示「收據已發送至您的電郵」',
    appAccessEnabledHelperText: '標記此場地是否開放手機應用程式。應用程式端尚未生效，因此暫時不會改變應用程式用戶看到的內容或可充電的地點。',
    kioskAccessEnabledHelperText: '允許在此場地登記付款亭',
    totalMaxPowerHelperText: '總最大功率容量（kW）',
    gridCapacityHelperText: '電網連接容量（kW）',
    notesHelperText: '附加備註或特殊說明',
    primaryImageHelperText: '主要充電站圖片的網址',
    qrCodeHelperText: '留空自動生成，或輸入 4 個字元（例如：A3K9）',
    vendorHelperText: '選擇要關聯至此充電站的商戶（選填）',
  },
  kioskBayWarning: {
    title: '部分充電樁不會在付款亭顯示',
    body: '以下充電樁沒有編號，付款亭不會列出，也無法在其上開始充電：%{names}。',
    andMore: '及其他 %{count} 個',
    partial: '只檢查了此場地首 %{count} 個充電樁。',
  },
  kioskSettings: {
    title: '付款亭編號名稱',
    intro: '此場地每個充電樁都有一個編號。請選擇付款亭如何稱呼這個編號，例如「車位 B03」或「充電樁 B03」。',
    presetLabel: '名稱',
    other: '其他',
    singular: '名稱（單數）',
    plural: '名稱（複數）',
    singularHelper: '顯示在單一編號前，例如「車位 B03」',
    pluralHelper: '用於數量，例如「2 個車位已插上充電線」',
    save: '儲存',
    clear: '改用系統設定',
    saved: '已為此場地儲存名稱',
    cleared: '已清除此場地的名稱',
    source: {
      site: '已為此場地設定',
      partial: '此場地只設定了其中一項',
      inherited: '沿用系統設定',
    },
    inheritedHelper: '此場地未設定，將沿用系統設定。以下顯示的是內置預設 %{label} / %{plural}，未必是實際使用的名稱。如要為此場地設定，請選擇另一個名稱。',
    lengthError: '請輸入 1 至 20 個字元',
    unchanged: '沒有變更需要儲存',
    unavailable: '此伺服器尚未提供付款亭編號名稱設定。',
    loadError: '無法載入此場地的付款亭設定',
  },
  helpers: {
    primaryImage: '站點主圖片（建議尺寸：1200x800px）',
    images: '附加圖片（最多10張，建議尺寸：1200x800px）',
    operatingAccess: '表示此站點的營業時間類型',
    parkingRate: '例如：「$25/小時」或「免費」或「請聯繫查詢」',
    parkingPromotion: '例如：「充電首30分鐘免費」',
    heightLimit: '例如：「2.2米」或「無限制」',
    security: '例如：「24/7 閉路電視」或「保安員」',
    restrictionNotes: '任何其他限制或要求',
    amenities: '點擊切換此充電站提供的設施。選取的項目會在手機應用程式的站點詳情頁面顯示。',
  },
  amenityLabels: {
    wifi: '無線網絡',
    restroom: '洗手間',
    restaurants: '餐廳',
    shopping: '購物',
    covered_parking: '有蓋停車場',
    security_camera: '保安攝錄機',
    valet_parking: '代客泊車',
    '24_7': '24小時開放',
    wheelchair: '無障礙設施',
    cafe: '咖啡店',
    atm: '自動櫃員機',
    pharmacy: '藥房',
    convenience_store: '便利店',
    gas_station: '油站',
    hotel: '酒店',
    gym: '健身室',
    park: '公園',
    bank: '銀行',
    parking: '停車場',
  },
  notifications: {
    deleteSuccess: '充電站刪除成功',
    deleteError: '刪除充電站時發生錯誤',
    createSuccess: '充電站建立成功',
    updateSuccess: '充電站更新成功',
    imageUploaded: '圖片上傳成功',
    imagesUploaded: '已成功上傳 %{count} 張圖片',
    imageRemoved: '圖片已移除',
  },
  actions: {
    uploadImages: '上傳圖片',
    uploadImage: '上傳圖片',
    changeImage: '更換圖片',
  },
  errors: {
    maxImagesExceeded: '最多允許 %{max} 張圖片',
    uploadFailed: '上傳圖片失敗',
    invalidImageType: '無效的圖片格式。僅支援 PNG、JPEG 和 SVG 格式。',
    imageTooLarge: '圖片過大。最大大小為 5MB。',
  },
  multilang: {
    title: '多語言資訊',
    helperText: '為手機應用程式中顯示的欄位提供翻譯。英文為必填。',
    nameHelperText: '此語言的充電站名稱',
    addressHelperText: '此語言的地址（對於不同文字系統很有用）',
    notesHelperText: '此語言的備註或特殊說明',
    pricingInfoHelperText: '此語言的價格資訊與詳情',
    nonEnglishNote: '此翻譯為選填。如未提供，將使用英文版本。',
    copyFromBasic: '從基本資訊複製',
  },
  operatingHours: {
    title: '營業時間',
    quickTemplates: {
      title: '快速範本',
      247: '24/7',
      businessHours: '營業時間（9-5）',
      extendedHours: '延長時間',
      clearAll: '全部清除',
    },
    tabs: {
      individualDays: '個別日期',
      quickEdit: '快速編輯',
      preview: '預覽',
    },
    days: {
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      mon: '週一',
      tue: '週二',
      wed: '週三',
      thu: '週四',
      fri: '週五',
      sat: '週六',
      sun: '週日',
    },
    timeFields: {
      open: '開放',
      close: '關閉',
    },
    status: {
      closed: '休息',
      247: '24/7',
    },
    actions: {
      copyToAll: '複製到全部',
      apply: '套用',
      selectDays: '選擇日期',
      setHours: '設定選定日期的時間',
    },
    alerts: {
      selectMultipleDays: '選擇多個日期以套用相同的時間',
    },
    publicHolidays: {
      title: '公眾假期',
      setDifferentHours: '為公眾假期設定不同的時間',
      closedOnPublicHolidays: '公眾假期休息',
      siteWillBeClosed: '此充電站將在所有公眾假期休息',
      publicHolidayHours: '公眾假期時間：%{hours}',
    },
    specialDates: {
      title: '特定特殊日期',
      subtitle: '特定特殊日期（例如：聖誕節、新年）',
      show: '顯示',
      hide: '隱藏',
      showSpecialDates: '特定特殊日期',
      addSpecialDate: '新增特殊日期',
      editSpecialDate: '編輯特殊日期',
      noSpecialDates: '未配置特定日期。新增特定假期（例如：12月25日聖誕節）並設定自訂時間。',
      dateLabel: '日期',
      nameLabel: '名稱（例如：聖誕節、新年）',
      closedOnThisDate: '此日期休息',
      cancel: '取消',
      add: '新增',
      update: '更新',
    },
    preview: {
      hoursSummary: '時間摘要',
      displayPreview: '顯示預覽',
      everyDay: '每日',
      monFri: '週一至週五',
      satSun: '週六至週日',
      nextDay: '上午 12:00（翌日）',
    },
  },
};